import { Jwt } from '@/models/jwt/jwt.model';

export class JwtService {
    public static DecodeToken(token: string): any {
        if (!token) return null;

        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    }

    public DecodeTokenAs<T>(token: string): T | null {
        if (!token) return null;

        try {
            return token !== null ? (JSON.parse(token) as T) : null;
        } catch (e) {
            return null;
        }
    }

    public static DecodeTokenAsJwt(token: string | null): Jwt | null {
        if (!token) return null;
        try {
            const decodedToken = this.DecodeToken(token);
            return new Jwt(token, decodedToken);
        } catch (e) {
            return null;
        }
    }
}
